module.exports = __webpack_public_path__ + "img/lcslogo.241798b1.png";